import script from "./RouterItemProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./RouterItemProxy.vue?vue&type=script&setup=true&lang=js"

import "./RouterItemProxy.vue?vue&type=style&index=0&id=1f0d4f6e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0d4f6e"]])

export default __exports__